import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMExcelUploader from "src/components/UI/atoms/formFields/ATMExcelUploader/ATMExcelUploader";

type Props = {
  formikProps: FormikProps<any>;
  onClose: () => void;
  onPreview?: () => void;
};
const UploadExcelForm = ({ formikProps, onClose, onPreview }: Props) => {
  const { values, setFieldValue, isSubmitting } = formikProps;

  return (
    <div className="py-4 flex flex-col gap-2 bg-white w-full max-w-sm mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center border-b pb-2">
        <div className="text-xl font-semibold text-gray-800">
          Upload Excel File
        </div>
        <button
          type="button"
          className="text-gray-500 hover:text-gray-800 transition"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>

      {/* Reusable Excel Uploader */}
      <ATMExcelUploader
        label="Excel File"
        required
        selectedFile={values.file}
        onSelect={(file) => setFieldValue("file", file)}
        placeholder="Click to upload Excel"
      />

      {/* Preview link aligned bottom-right */}
      {values.file && (
        <div className="flex justify-end">
          <span
            role="button"
            tabIndex={0}
            onClick={onPreview}
            onKeyDown={(e) => e.key === "Enter" && onPreview}
            className="text-sm text-blue-600 underline hover:text-blue-700 cursor-pointer"
          >
            Preview Excel
          </span>
        </div>
      )}

      {/* Submit Button */}
      <div>
        <ATMLoadingButton
          isLoading={isSubmitting}
          type="submit"
          className="w-full bg-primary-main text-white py-3 rounded-lg"
        >
          Upload File
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default UploadExcelForm;
